import { connect } from "react-redux";
import PacketDownload from "./PacketDownload";
import { fetchDocumentsPacket } from "../confirmation/actions/documentPacket";

const mapDispachToProps = {
  fetchDocumentsPacket
};

export default connect(null, mapDispachToProps)(PacketDownload);
